<template>
  <div class="quick__nav">
    <div class="quick__nav__list flex wrap">
      <template v-for="(nav, index) in navList">
        <div
          v-if="nav.show"
          :class="{ active: index == activeNav }"
          @click="linkToArea(nav.key)"
          :data-scroll-id="`area-${nav.key}`"
          class="quick__nav__list__item"
          :key="nav.key"
        >
          {{ nav.name }}
        </div>
      </template>

      <div @mouseenter="download = true" @mouseleave="download = false" class="quick__nav__list__item" key="download">
        APP下载
      </div>
      <div @click="backTop" class="quick__nav__list__top flex wrap center pointer">
        <i class="el-icon-arrow-up"></i>
        <span>回到顶部</span>
      </div>
    </div>
    <div class="download" v-if="download">
      <img class="download_bg" src="@/assets/img/download.png" alt="" />
      <img class="download_qr" src="https://www.zyhealth.com/assets/wenzhen-qr.08ed4f2.png" alt="" />
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash';

export default {
  props: ['active', 'goodsDrug', 'goodsRecommend'],
  data() {
    return {
      timer: null,
      header: null,
      activeNav: null,
      onscroll: true,
      navList: [
        { name: '热门活动', key: 'active' },
        { name: '品质好药', key: 'goodsDrug' },
        { name: '商品推荐', key: 'goodsRecommend' }
      ],
      areaList: [],
      download: false
    };
  },
  methods: {
    backTop() {
      const el = document.querySelector('.layout-component');
      el.scrollTo({ top: 0, behavior: 'smooth' });
    },
    // 初始化获取快捷导航对应的区域数值
    init() {
      this.timer && clearInterval(this.timer);
      this.header = document.querySelector('.el-header').offsetHeight;
      this.timer = setInterval(() => {
        if (!this.goodsDrug || document.querySelector(`#goodsDrug`)) {
          clearInterval(this.timer);
        }
        this.areaList = this.navList.map(item => {
          const ele = document.querySelector(`#${item.key}`);
          if (ele) {
            return { id: item.key, offsetTop: ele.offsetTop + this.header, height: ele.offsetHeight };
          } else return item;
        });
      }, 1000);
    },
    beforeDestroy() {
      this.$store.dispatch('layout/SET_FOOTER', true);
      this.timer && clearInterval(this.timer);
    },
    // 跟随内容区
    linkToArea(id) {
      if (id === 'download') {
        this.download = !this.download;
      } else {
        let offsetTop = this.getOffsetTop(id);
        const el = document.querySelector('.layout-component');
        el.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    },
    // 获取区域id对应的高度
    getOffsetTop(id) {
      let area = document.querySelector(`#${id}`);
      return area.offsetTop;
    },
    // 更新快捷导航索引
    updateActiveNav() {
      const el = document.querySelector('.layout-component');
      let scrollTop = el.scrollTop;
      this.areaList.forEach(ele => {
        if (ele.offsetTop - scrollTop <= 0 && ele.offsetTop + ele.height - scrollTop > 0) {
          this.navList.forEach((nav, index) => {
            if (ele.id == nav.key) {
              this.activeNav = index;
            }
          });
        }
      });
    }
  },
  created() {
    this.navList.map(item => {
      // 是否显示
      item.show = this[item.key];
    });
    const ele = document.querySelector('.layout-component');
    ele.onscroll = throttle(this.updateActiveNav, 20, { leading: true, trailing: true });
  },
  mounted() {
    this.init();
  },
  destroyed() {
    const ele = document.querySelector('.layout-component');
    if (ele && ele.onscroll) {
      ele.onscroll = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.quick__nav {
  position: fixed;
  height: fit-content;
  width: 64px;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 10;
  &__list {
    box-shadow: 0px 0px 2px #aaaaaa;
    &__item {
      position: relative;
      display: inline-block;
      width: 64px;
      height: 64px;
      cursor: pointer;
      margin-bottom: 1px;
      padding: 16px;
      font-size: 14px;
      font-weight: 400;
      color: #262626;
      background: #ffffff;
      line-height: 18px;
      &::after {
        position: absolute;
        display: inline-block;
        width: 56px;
        height: 1px;
        left: 50%;
        transform: translateX(-50%);
        bottom: -1px;
        background: #f9f9f9;
        z-index: 1;
        content: '';
      }
    }
    &__top {
      width: 64px;
      height: 52px;
      padding: 12px 8px;
      font-size: 12px;
      font-weight: 400;
      line-height: 1;
      color: #262626;
      background: #ffffff;
    }
  }
  .download {
    width: 198px;
    height: 274px;
    position: fixed;
    right: 64px;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 10;
    &_bg {
      width: 198px;
      height: 274px;
    }
    &_qr {
      width: 100px;
      height: 100px;
      position: relative;
      bottom: 125px;
      left: 47px;
    }
  }

  .active {
    font-weight: 500;
    color: #ffffff;
    background: #1e8dff;
  }
}
</style>
